import { useState, useMemo } from "react"
import { Modal } from "components"
import Label from "components/forms/label"
import Input from "components/forms/input"
import SelectDescription from "components/forms/select-description"
import { lang } from "config"

import useBranchRepositories from "repositories/branch"

const Content = ({ data, errors, onSubmit, onRemove }) => {
  const [outlet_id, setOutletId] = useState(data.outlet || data.outlet_id || "")
  const [type, setType] = useState(data.type || "")
  const [status, setStatus] = useState(data.status || "")
  const [date_from, setDateFrom] = useState(data.dateFrom || data.date_from || "")
  const [date_to, setDateTo] = useState(data.dateTo || data.date_to || "")

  const { data: outletSelection, isLoading: isLoadingOutletSelection } =
    useBranchRepositories({ paginate: false })

  const outletOptions = useMemo(() => outletSelection || [], [outletSelection])

  const typeOptions = [
    { id: "CREDIT", name: "CREDIT" },
    { id: "DEBIT", name: "DEBIT" },
  ]

  const statusOptions = [
    { id: "OPEN", name: "OPEN" },
    { id: "PARTIAL", name: "PARTIAL" },
    { id: "USED", name: "USED" },
    { id: "EXPIRED", name: "EXPIRED" },
    { id: "CANCELLED", name: "CANCELLED" },
  ]

  const handleSubmit = (e) => {
    e.preventDefault()

    const payload = {
      outlet_id,
      type,
      status,
      date_from,
      date_to,
    }

    onSubmit(
      Object.fromEntries(
        Object.entries(payload).filter(([_, v]) => v != null && v !== "")
      )
    )
  }

  return (
    <form onSubmit={handleSubmit} className="mt-8 space-y-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <Label value="Outlet" />
          <SelectDescription
            selection={outletOptions}
            isLoading={isLoadingOutletSelection}
            value={outlet_id}
            onChange={(value) => setOutletId(value)}
            keyValue={(v) => v.id}
            title={(v) => v.name}
            description={(v) => v.code || v.id}
            placeholder="Pilih Outlet"
          />
        </div>

        <div>
          <Label value="Tipe" />
          <SelectDescription
            selection={typeOptions}
            value={type}
            onChange={(value) => setType(value)}
            keyValue={(v) => v.id}
            title={(v) => v.name}
            placeholder="Pilih Tipe"
          />
        </div>

        <div>
          <Label value="Status" />
          <SelectDescription
            selection={statusOptions}
            value={status}
            onChange={(value) => setStatus(value)}
            keyValue={(v) => v.id}
            title={(v) => v.name}
            placeholder="Pilih Status"
          />
        </div>

        <div>
          <Label value="Tanggal Dari" />
          <Input
            type="date"
            value={date_from || ""}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </div>

        <div>
          <Label value="Tanggal Sampai" />
          <Input
            type="date"
            value={date_to || ""}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </div>
      </div>

      <div className="flex items-center space-x-2 text-xs">
        <button
          type="submit"
          className="px-6 py-3 text-white transition bg-brand-800 rounded-xl"
        >
          {lang.filter}
        </button>

        <button
          type="button"
          onClick={onRemove}
          className="px-6 py-3 transition border border-neutral-200 bg-neutral-50 rounded-xl"
        >
          {lang.clear}
        </button>
      </div>
    </form>
  )
}

const Filter = ({ data, errors, onSubmit, onRemove }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  const handleSubmit = (value) => {
    closeModal()
    onSubmit(value)
  }

  const handleRemove = () => {
    closeModal()
    onRemove()
  }

  return (
    <>
      <button
        onClick={openModal}
        className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4"
          viewBox="0 0 24 24"
          strokeWidth={1}
          stroke="currentColor"
          fill="none"
        >
          <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5" />
        </svg>

        <span>{lang.filter}</span>

        {Object.keys(data || {}).length > 0 && (
          <span className="inline-flex w-4 h-4 font-semibold rounded-full text-[0.5rem] justify-center text-neutral-200 bg-brand-800">
            {Object.keys(data).length}
          </span>
        )}
      </button>

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={`${lang.filter} ${lang.data}`}
        content={
          <Content
            errors={errors}
            onSubmit={handleSubmit}
            onRemove={handleRemove}
            data={data || {}}
          />
        }
      />
    </>
  )
}

export default Filter
